// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let SharedPostEmailStatsSingleRecipient = require("./SharedPostEmailStatsSingleRecipient.bs.js");
let SharedPostEmailStatsButtonQuery_graphql = require("../../../__generated__/SharedPostEmailStatsButtonQuery_graphql.bs.js");

let convertVariables = SharedPostEmailStatsButtonQuery_graphql.Internal.convertVariables;

let convertResponse = SharedPostEmailStatsButtonQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = SharedPostEmailStatsButtonQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, SharedPostEmailStatsButtonQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, SharedPostEmailStatsButtonQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(SharedPostEmailStatsButtonQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(SharedPostEmailStatsButtonQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SharedPostEmailStatsButton$Modal(props) {
  let onRefresh = props.onRefresh;
  let data = usePreloaded(props.queryRef);
  let match = data.sharedPropertyV5;
  if (match === undefined) {
    return JsxRuntime.jsx(FragmentErrorBoundary.ErrorState.make, {
      fragmentDisplayName: "email stats"
    });
  }
  if (match.__typename !== "SharedPropertyV5") {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + match._0 + ` in SharedPostEmailStatsButton query`);
  }
  let recipients = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.flatMap(match.contacts, c => c.edges), [])).map(r => r.emailStats);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
          onClick: param => onRefresh(),
          size: "small",
          _type: "button",
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "refresh",
                size: 16
              }),
              "Refresh stats"
            ],
            className: "flex items-center gap-2"
          })
        }),
        className: "flex flex-row justify-end mb-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("ul", {
          children: [
            JsxRuntime.jsxs("li", {
              children: [
                JsxRuntime.jsx("div", {
                  children: "Recipient",
                  className: "text-left p-4 font-medium text-gray-700"
                }),
                JsxRuntime.jsx("div", {
                  children: "Status",
                  className: "text-right p-4 font-medium text-gray-700"
                }),
                JsxRuntime.jsx("div", {
                  children: "Clicks",
                  className: "text-right p-4 font-medium text-gray-700"
                }),
                JsxRuntime.jsx("div", {
                  children: "Last clicked",
                  className: "text-right p-4 font-medium text-gray-700"
                })
              ],
              className: "hidden md:grid md:grid-cols-4 bg-gray-50"
            }),
            recipients.map((r, index) => JsxRuntime.jsx(SharedPostEmailStatsSingleRecipient.make, {
              recipient: r.fragmentRefs
            }, index.toString()))
          ],
          className: "w-full divide-y divide-gray-200 bg-white"
        }),
        className: "rounded-lg border border-gray-200 overflow-hidden"
      })
    ],
    className: "min-w-[320px]"
  });
}

let Modal = {
  make: SharedPostEmailStatsButton$Modal
};

function SharedPostEmailStatsButton(props) {
  let sharedMessageId = props.sharedMessageId;
  let match = useLoader();
  let loadQuery = match[1];
  let queryRef = match[0];
  let match$1 = React.useState(() => false);
  let setShowModal = match$1[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(DialogV5.make, {
        title: "Email Stats",
        isOpen: match$1[0],
        ariaLabel: "Email Stats",
        onDismiss: () => setShowModal(param => false),
        size: "XXLarge",
        showCloseButton: true,
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "This shows how recipients have engaged with your email",
              className: "prose max-w-none"
            }),
            className: "mb-4"
          }),
          queryRef !== undefined ? JsxRuntime.jsx(React.Suspense, {
              children: JsxRuntime.jsx(FragmentErrorBoundary.make, {
                fragmentDisplayName: "email stats",
                children: JsxRuntime.jsx(SharedPostEmailStatsButton$Modal, {
                  queryRef: Primitive_option.valFromOption(queryRef),
                  onRefresh: () => loadQuery({
                    sharedMessageId: sharedMessageId
                  }, "network-only", undefined)
                })
              }),
              fallback: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Loader.make, {}),
                className: "mt-4"
              })
            }) : null,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => setShowModal(param => false),
              _type: "button",
              children: "Close"
            }),
            className: "flex flex-row justify-end gap-4 mt-10"
          })
        ]
      }),
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => {
          loadQuery({
            sharedMessageId: sharedMessageId
          }, "network-only", undefined);
          setShowModal(param => true);
        },
        size: "small",
        children: "Email Stats"
      })
    ]
  });
}

let make = SharedPostEmailStatsButton;

exports.Query = Query;
exports.Modal = Modal;
exports.make = make;
/* use Not a pure module */
